//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';
import {TestSessionResultsSaveRequest} from '../../../../../../types/esgi.apigateway/api/controllers/v2/teachers/modules/user-settings/test-session-results-save-request';
import {BaseResponse} from '../../../../../../types/esgi.app/endpoints/abstractions/base-response';

export function tabsTestSessionResultsSave(httpClient: ContractHttpClient) {
	return (inModel: TestSessionResultsSaveRequest): Observable<BaseResponse> => {
		return httpClient.request<BaseResponse>(
			'POST',
			'/v2/teachers/modules/user-settings/tabs/test-session-results/save',
			inModel,
		).asObservable();
	};
}
